import { render, staticRenderFns } from "./Capture.vue?vue&type=template&id=48a5531f&scoped=true"
import script from "./Capture.vue?vue&type=script&lang=js"
export * from "./Capture.vue?vue&type=script&lang=js"
import style0 from "./Capture.vue?vue&type=style&index=0&id=48a5531f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a5531f",
  null
  
)

export default component.exports